import { Transformer } from './Transformer';
import {
  IDeleteRequestOptions,
  IGetRequestOptions,
  IPatchRequestOptions,
  IPostRequestOptions,
  IPutRequestOptions,
  IResponse
} from './RequestOptions';
import { API } from '../constants/API';
import { HttpStatusCode } from './HttpStatusCode';
import { setItem } from '../../services/session-storage.service';
import { Header } from './Header';

type requestProps = {
  status: number;
  statusText: any;
  body: any;
  headers: any;
  /*pagination: {
    previousPage: any;
    nextPage: any;
  };*/
};

type request = {
  fullUrl: any;
  init: {
    method: any;
    headers: Headers;
    body: string;
//    credentials: RequestCredentials;
    signal: any;
  };
  preventRetryOnStatus: any;
  maxRetries: any;
};

async function ProcessFetch(req: request): Promise<requestProps> {
//  req.init.credentials = 'include' as RequestCredentials;
  let transformedResponse = await Transformer.fetch(req);

  // Request for a new token
  if (transformedResponse.status === 401) {
    const tokenRequest = {
      fullUrl: req.fullUrl,
      init: {
        method: 'GET',
        headers: req.init.headers,
        body: null,
//        credentials: 'include' as RequestCredentials,
        signal: req.init.signal
      },
      preventRetryOnStatus: req.preventRetryOnStatus,
      maxRetries: req.maxRetries
    };
    const response = await fetch(`${API.AUTH_SERVICE}/getToken`, tokenRequest.init);

    transformedResponse = await Transformer.transform(req, response);
    if (transformedResponse.status.toString() === HttpStatusCode.OK && transformedResponse.body.error === 0) {
      const token = transformedResponse.body.token;
      setItem('token', token);
      req.init.headers.set(Header.AUTHORIZATION, `Bearer ${token}`);
      transformedResponse = await Transformer.fetch(req);
    }
  }

  return transformedResponse;
}

const RequestWrapper = {
  get: async <ResponseBody>(url: string, options?: IGetRequestOptions): Promise<IResponse<ResponseBody>> => {
    const request = await Transformer.createRequestInfo('GET', url, options);
    return ProcessFetch(request);
  },
  getPaginated: async <ResponseBody>(url: string, options?: IGetRequestOptions): Promise<IResponse<ResponseBody[]>> => {
    return Transformer.fetchPaginated(url, options);
  },
  put: async <ResponseBody, RequestBody>(url: string, options?: IPutRequestOptions<RequestBody>): Promise<IResponse<ResponseBody>> => {
    const request = await Transformer.createRequestInfo('PUT', url, options);
    return ProcessFetch(request);
  },
  patch: async <ResponseBody, RequestBody>(
    url: string,
    options?: IPatchRequestOptions<RequestBody>
  ): Promise<Readonly<IResponse<ResponseBody>>> => {
    const request = await Transformer.createRequestInfo('PATCH', url, options);
    return ProcessFetch(request);
  },
  post: async <ResponseBody, RequestBody>(
    url: string,
    options?: IPostRequestOptions<RequestBody>
  ): Promise<Readonly<IResponse<ResponseBody>>> => {
    const request = await Transformer.createRequestInfo('POST', url, options);

    return ProcessFetch(request);
  },
  delete: async <ResponseBody>(url: string, options?: IDeleteRequestOptions): Promise<Readonly<IResponse<ResponseBody>>> => {
    const request = await Transformer.createRequestInfo('DELETE', url, options);
    return ProcessFetch(request);
  }
};

export default RequestWrapper;
